import React, { useEffect, useState } from "react";
import { Badge, Group, Button } from "@mantine/core";
import axios from "axios";
import { API } from "utiles/url";

const STATUSES = [
  { key: "PENDING", label: "Pending", color: "#FF6A00" },
  { key: "STARTED", label: "Started", color: "#FF6A00" },
  { key: "FINISHED", label: "Finished", color: "#FF6A00" },
  { key: "DRIVER_REQUESTING", label: "Driver Requesting", color: "#FF6A00" },
  { key: "DRIVER_ACCEPTED", label: "Accepted", color: "#FF6A00" },
  { key: "MISSED_CALL", label: "Missed Call", color: "#FF6A00" },
];

export default function DropOffCard({
  onCardClick,
  handelSearch,
  clearFilter,
  selectedStatus,
}) {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchDropOffs();
  }, []);

  const fetchDropOffs = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("auth_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await axios.get(`${API}/dropoff/status-counts`, config);
      if (data) {
        setLoading(false);
        setData(data);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const handleStatusClick = (status) => {
    onCardClick(status);
    handelSearch(null);
  };

  const handleClearFilter = () => {
    clearFilter();
  };

  const getButtonStyles = (status) => ({
    root: {
      fontWeight: 600,
      backgroundColor: selectedStatus === status ? "#FF6A00" : "transparent",
      color: selectedStatus === status ? "white" : "rgb(20, 61, 89)",
      border: `1px solid ${selectedStatus === status ? "#FF6A00" : "#ddd"}`,
      padding: "8px 12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      minWidth: "120px",
      height: "36px",
      transition: "all 0.2s ease",
      "&:hover": {
        color: "#FFFFFF",
        backgroundColor: "#FF6A00",
        "& .mantine-Badge-root": {
          backgroundColor: "white",
          color: "#FF6A00",
        },
      },
    },
    inner: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
    },
  });

  const getBadgeStyles = (status, color) => ({
    backgroundColor: selectedStatus === status ? "white" : color,
    color: selectedStatus === status ? "#FF6A00" : "white",
    marginLeft: 8,
    fontSize: "12px",
    padding: "0 8px",
    height: "20px",
    lineHeight: "20px",
  });

  return (
    <Group spacing="sm" position="left" style={{ paddingBottom: 7 }}>
      {STATUSES.map(({ key, label, color }) => (
        <Button
          key={key}
          onClick={() => handleStatusClick(key)}
          radius="md"
          styles={getButtonStyles(key)}
        >
          <span>{label}</span>
          <Badge size="sm" style={getBadgeStyles(key, color)}>
            {data?.[key] > 0 ? data[key] : 0}
          </Badge>
        </Button>
      ))}
      <Button
        onClick={handleClearFilter}
        radius="md"
        styles={{
          root: {
            fontWeight: 600,
            backgroundColor: selectedStatus === null ? "#666666" : "#808080",
            color: "white",
            minWidth: "60px",
            padding: "8px 12px",
            height: "36px",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: selectedStatus === null ? "#666666" : "#909090",
            },
          },
        }}
      >
        All
      </Button>
    </Group>
  );
}